"use client";

import { Typography } from "@/components/ui/typography";
import Image from "next/image";

type LogoItem = {
  id: number;
  src: string;
  alt: string;
};

type DocumentsLogoProps = {
  content: {
    titleLogo?: string;
    logoSectionLast?: {
      fields?: {
        title?: string;
        file?: {
          url?: string;
        };
      };
    }[];
  };
};

export default function DocumentsLogo({ content }: DocumentsLogoProps) {
  const title = content.titleLogo;

  const logos: LogoItem[] =
    content.logoSectionLast?.map((item, idx) => ({
      id: idx,
      src: item.fields?.file?.url ? "https:" + item.fields.file.url : "",
      alt: item.fields?.title ?? "",
    })) ?? [];

  return (
    <section className="section bg-white lg:bg-background-secondary border border-neutral-200 md:border-0">
      <div className="container py-12 lg:py-20 mx-auto">
        <div className="grid grid-cols-1 gap-6 lg:gap-12">
          {!!title && (
            <Typography
              variant="subHeadingLg"
              className="text-gray-800 md:text-center md:text-[2rem] md:text-[150%] md:font-medium"
              asChild
            >
              <h3>{title}</h3>
            </Typography>
          )}
          {!!logos?.length && (
            <div className="flex flex-wrap items-center md:justify-center gap-[34px] lg:gap-[min(40px,3.5vw)]">
              {logos.map(({ id, src, alt }) =>
                src ? (
                  <div className="flex justify-center" key={id}>
                    <Image
                      width={200}
                      height={76}
                      quality={100}
                      src={src}
                      alt={alt}
                      className="object-contain h-[60px] w-auto"
                    />
                  </div>
                ) : null
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
